import Vue from 'vue'
import axios from 'axios'
import vuetify from './plugins/vuetify'
import '@/components/global/globalComponents'
import App from './App.vue'
import store from './store'
import router from './router'
import moment from 'moment'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

moment.locale('fr')
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('security/logout')
    } else if (error.response.status === 500) {
      store.dispatch('exception/newException', 'Une erreur est survenue')
    } else if (error.response.status !== 404) {
      store.dispatch('exception/newException', error.response.data)
    }
    return Promise.reject(error)
  }
)

Vue.use(PerfectScrollbar)

new Vue({
  render: (h) => h(App),
  store,
  vuetify,
  router,
  created() {
    this.$store.dispatch('security/retrieveTokenFromStorage')
    this.$store.dispatch('application/retrieveSelectedEtablissementFromStorage')
  },
}).$mount('#app')
